<template>
  <footer class="footer-wrap clearfix" v-if="setting !== null">
    <div class="max-width-wrap clearfix">
      <div class="tablet-wrap clearfix">
        <div class="column-one">
          <a :href="homeUrl" class="logo">
            <template v-if="siteInfo.site_logo_dark">
              <img :src="siteInfo.site_logo_dark" :alt="companyName" />
            </template>
            <template v-else>
              <strong class="site-name-fallback">
                {{ companyName }}
              </strong>
            </template>
          </a>

          <div class="address-wrap">
            <img src="/assets/images/pin-icon-v1.svg" alt="" class="pin-icon" />
            <div class="address">
              <p>Abu Dhabi, UAE</p>
            </div>
          </div>

          <div class="email-wrap">
            <img
              src="/assets/images/mail-icon-v1.svg"
              alt=""
              class="mail-icon"
            />
            <a href="mailto:support@mywhoosh.com" class="email"
              >Support@mywhoosh.com</a
            >
          </div>

          <div class="copyright-wrap-desktop">
            <p>&copy; {{ year }} {{ companyName }}. All rights reserved.</p>
          </div>
        </div>

        <div class="column-two" v-if="hasNavigationMenu">
          <h2>{{ navigationMenuTitle }}</h2>
          <ul class="list-unstyled">
            <li v-for="item in getFooterNavigationMenu.items" :key="item.ID">
              <a class="page-hyper-link" :href="item.url" :target="item.target || '_self'" :title="item.attr_title">
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>

        <div class="column-three" v-if="hasCommunityMenu">
          <h2>{{ communityMenuTitle }}</h2>
          <ul class="list-unstyled">
            <li v-for="item in getFooterCommunityMenu.items" :key="item.ID">
              <a class="page-hyper-link" :href="item.url" :target="item.target || '_self'" :title="item.attr_title">
                {{ item.title }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="column-four clearfix">
        <h2>Find Us On Social Media</h2>
        <a v-for="social in socialMediaLinks" :key="social.name" class="social-link" :href="social.url"
          :aria-label="social.name">
          <img :src="social.icon" :alt="social.name" />
        </a>
      </div>

      <div class="copyright-wrap-mobile">
        <p>&copy; {{ year }} {{ companyName }}. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/commonMixin";
import { email, required } from "vuelidate/lib/validators";

export default {
  name: "FooterComponent",
  mixins: [commonMixin],

  data() {
    return {
      submitted: false,
      form: { email: null },
      year: new Date().getFullYear(),
      wpURL: process.env.VUE_APP_WEB_URL,
    };
  },

  computed: {
    ...mapGetters("auth", ["user", "loggedIn"]),
    ...mapGetters("page", ["setting"]),
    ...mapGetters("common", ["getSubscribed"]),
    ...mapGetters("menu", [
      "getFooterNavigationMenu",
      "getFooterCommunityMenu",
      "siteInfo",
    ]),

    homeUrl() {
      return this.siteInfo.home_url || this.wpURL;
    },

    companyName() {
      return this.siteInfo.name || "MyWhoosh";
    },

    hasNavigationMenu() {
      return this.getFooterNavigationMenu?.items?.length > 0;
    },

    hasCommunityMenu() {
      return this.getFooterCommunityMenu?.items?.length > 0;
    },

    navigationMenuTitle() {
      return (
        this.getFooterNavigationMenu?.menu_name?.replace(
          /Menu$/i,
          ""
        ) || "Navigation"
      );
    },

    communityMenuTitle() {
      return (
        this.getFooterCommunityMenu?.menu_name?.replace(/Menu$/i, "") ||
        "Community"
      );
    },

    socialMediaLinks() {
      if (!this.setting) return [];

      const socialLinks = [
        {
          name: "Facebook",
          url: this.setting.facebook || "javascript:void(0)",
          icon: "/assets/images/facebook-logo-v1.svg",
        },
        {
          name: "Twitter",
          url: this.setting.twitter || "javascript:void(0)",
          icon: "/assets/images/twitter-logo-v1.svg",
        },
        {
          name: "LinkedIn",
          url: this.setting.linkedin || "javascript:void(0)",
          icon: "/assets/images/linkedin-logo-v1.svg",
        },
        {
          name: "Instagram",
          url: this.setting.instagram || "javascript:void(0)",
          icon: "/assets/images/instagram-logo-v1.svg",
        },
        {
          name: "YouTube",
          url: this.setting.youtube || "javascript:void(0)",
          icon: "/assets/images/youtube-logo-v1.svg",
        },
        {
          name: "Strava",
          url: this.setting.strava || "javascript:void(0)",
          icon: "/assets/images/strava-logo-v1.svg",
        },
      ];

      return socialLinks;
    },

    getUserName() {
      return this.user
        ? `${this.user.firstname} ${this.user.lastname}`
        : null;
    },
  },

  validations: {
    form: { email: { required, email } },
  },

  async mounted() {
    try {
      await this.$store.dispatch("page/setting");
    } catch (error) {
      console.error("Error loading footer data:", error);
    }
  },

  methods: {
    submitHandler() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;
      this.$store.dispatch("common/subscribe", this.form);
    },
  },
};
</script>
